import { render, staticRenderFns } from "./RuleCreatedModal.vue?vue&type=template&id=75991648&"
import script from "./RuleCreatedModal.vue?vue&type=script&lang=js&"
export * from "./RuleCreatedModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleCreatedModal.vue?vue&type=style&index=0&id=75991648&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports